import { PluginsContext } from 'plugins'
import { useContext } from 'react'

export const usePluginsContext = () => {
    return useContext(PluginsContext)
}